import { TimeRecordDataService } from '../services/timeRecordDataService'

export const useTimeRecordData = (userId: string) => {
  const clients = TimeRecordDataService.getClientsForUser(userId)

  const customers = clients.map((c) => ({
    id: c.id,
    label: c.name,
    value: c.id,
  }))

  return { customers }
}
